module.exports = __webpack_public_path__ + "images/shadow-of-the-colossus_rgba(0,0,0,0.7).715753d6d60669c5b7fc05d510eb7dd1.jpg";